// import React from 'react';
// import { TextField, FormControl, InputLabel, MenuItem, Select, Button, Tooltip, Grid } from '@mui/material';
// import { noop } from 'lodash-es';
// import useAuth from 'hooks/useAuth';
// import { emailRegExp } from 'utils/constant';

// const applicationAreas = [
// 	{ id: 'general', value: 'General' },
// 	{ id: 'assessments', value: 'Assessments' },
// 	{ id: 'sessions', value: 'Sessions' },
// 	{ id: 'profile', value: 'Profile' },
// 	{ id: 'library', value: 'Library' },
// 	{ id: 'others', value: 'Others' }
// ];

// const AppFeedback = ({ onClose = noop }) => {
// 	const { isLoggedIn } = useAuth();
// 	const [feedback, setFeedback] = React.useState({
// 		area: 'general',
// 		name: '',
// 		email: '',
// 		phoneNumber: '',
// 		description: ''
// 	});

// 	const updateFeeback = (prop, value) => {
// 		setFeedback(prev => ({ ...prev, [prop]: value }));
// 	};

// 	const handleAreaChange = ({ target }) => updateFeeback('area', target.value);
// 	const onDescriptionChange = ({ target }) => updateFeeback('description', target.value);
// 	const onEmailChange = ({ target }) => updateFeeback('email', target.value);
// 	const onPhoneChange = ({ target }) => updateFeeback('phoneNumber', target.value);
// 	const onNameChange = ({ target }) => updateFeeback('name', target.value);

// 	const hasRequiredFields = () =>
// 		isLoggedIn
// 			? feedback.area && feedback.name && feedback.email && feedback.description
// 			: !!feedback.area && !!feedback.description;

// 	const handleOnSubmit = () => {
// 		if (hasRequiredFields()) onClose(feedback);
// 	};

// 	const handleOnClose = () => onClose();

// 	return (
// 		<Grid container>
// 			<Grid item xs={12}>
// 				<FormControl variant='standard' sx={{ my: 3, width: '100%' }}>
// 					<InputLabel id='feedback-application-areas-label'>Application Feature</InputLabel>
// 					<Select
// 						autoFocus
// 						margin='dense'
// 						labelId='feedback-application-areas-label'
// 						id='feedback-application-areas-select'
// 						value={feedback.area}
// 						label='Application Feature'
// 						required={isLoggedIn}
// 						onChange={handleAreaChange}
// 						disabled={!isLoggedIn}>
// 						{applicationAreas.map(item => (
// 							<MenuItem key={item.id} value={item.id}>
// 								{item.value}
// 							</MenuItem>
// 						))}
// 					</Select>
// 				</FormControl>
// 				{!isLoggedIn && (
// 					<>
// 						<TextField
// 							variant='standard'
// 							sx={{ mb: 2 }}
// 							value={feedback.name}
// 							onChange={onNameChange}
// 							margin='dense'
// 							id='feedback-application-name'
// 							InputLabelProps={{
// 								shrink: true
// 							}}
// 							label='Name'
// 							fullWidth
// 							required
// 						/>
// 						<TextField
// 							variant='standard'
// 							sx={{ mb: 2 }}
// 							value={feedback.email}
// 							onChange={onEmailChange}
// 							error={Boolean(feedback.email) && !emailRegExp.test(feedback.email)}
// 							helperText={
// 								feedback.email &&
// 								!emailRegExp.test(feedback.email) &&
// 								'Please enter a valid email address.'
// 							}
// 							margin='dense'
// 							id='feedback-application-email'
// 							InputLabelProps={{
// 								shrink: true
// 							}}
// 							label='Email Address'
// 							fullWidth
// 							required
// 						/>
// 						<TextField
// 							variant='standard'
// 							sx={{ mb: 2 }}
// 							value={feedback.phoneNumber}
// 							onChange={onPhoneChange}
// 							margin='dense'
// 							id='feedback-application-phone'
// 							InputLabelProps={{
// 								shrink: true
// 							}}
// 							label='Phone Number'
// 							fullWidth
// 						/>
// 					</>
// 				)}
// 				<TextField
// 					variant='standard'
// 					sx={{ overflowY: 'visible', height: 'auto' }}
// 					value={feedback.description}
// 					onChange={onDescriptionChange}
// 					margin='dense'
// 					id='feedback-application-description'
// 					InputLabelProps={{
// 						shrink: true
// 					}}
// 					label='Feedback Description'
// 					multiline
// 					required
// 					rows={4}
// 					fullWidth
// 				/>
// 			</Grid>
// 			<Grid item xs={12} alignItems='center' justifyContent='space-between'>
// 				<Button onClick={handleOnClose} className='cancel-button'>
// 					Cancel
// 				</Button>
// 				<Tooltip
// 					arrow
// 					title='Submit feedback'
// 					placement='top'
// 					disableFocusListener={!!feedback.description}
// 					disableHoverListener={!!feedback.description}
// 					disableTouchListener={!!feedback.description}>
// 					<Button
// 						id='feedback-application-submit'
// 						onClick={handleOnSubmit}
// 						disabled={!hasRequiredFields()}
// 						component='div'
// 						className='submit-button'>
// 						Submit
// 					</Button>
// 				</Tooltip>
// 			</Grid>
// 		</Grid>
// 	);
// };

// export default AppFeedback;


import React from 'react';
import { TextField, FormControl, InputLabel, MenuItem, Select, Button, Tooltip, Grid } from '@mui/material';
import { noop } from 'lodash-es';
import useAuth from 'hooks/useAuth';
import { emailRegExp } from 'utils/constant';

const applicationAreas = [
    { id: 'general', value: 'General' },
    { id: 'assessments', value: 'Assessments' },
    { id: 'sessions', value: 'Sessions' },
    { id: 'profile', value: 'Profile' },
    { id: 'library', value: 'Library' },
    { id: 'others', value: 'Others' }
];

const AppFeedback = ({ onClose = noop }) => {
    const { isLoggedIn } = useAuth();
    const [feedback, setFeedback] = React.useState({
        area: 'general',
        name: '',
        email: '',
        phoneNumber: '',
        description: ''
    });

    const updateFeeback = (prop, value) => {
        setFeedback(prev => ({ ...prev, [prop]: value }));
    };

    const handleAreaChange = ({ target }) => updateFeeback('area', target.value);
    const onDescriptionChange = ({ target }) => updateFeeback('description', target.value);
    const onEmailChange = ({ target }) => updateFeeback('email', target.value);
    const onPhoneChange = ({ target }) => updateFeeback('phoneNumber', target.value);
    const onNameChange = ({ target }) => updateFeeback('name', target.value);

    // --- THIS IS THE PRIMARY FIX ---
    // The validation logic is now flipped to match the form fields.
    const hasRequiredFields = () =>
        !isLoggedIn
            ? feedback.area && feedback.name && emailRegExp.test(feedback.email) && feedback.description
            : !!feedback.area && !!feedback.description;

    const handleOnSubmit = () => {
        if (hasRequiredFields()) onClose(feedback);
    };

    const handleOnClose = () => onClose();

    return (
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant='standard' sx={{ my: 3, width: '100%' }}>
                    <InputLabel id='feedback-application-areas-label'>Application Feature</InputLabel>
                    <Select
                        autoFocus
                        margin='dense'
                        labelId='feedback-application-areas-label'
                        id='feedback-application-areas-select'
                        value={feedback.area}
                        label='Application Feature'
                        required={isLoggedIn}
                        onChange={handleAreaChange}
                        disabled={!isLoggedIn}>
                        {applicationAreas.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {!isLoggedIn && (
                    <>
                        <TextField
                            variant='standard'
                            sx={{ mb: 2 }}
                            value={feedback.name}
                            onChange={onNameChange}
                            margin='dense'
                            id='feedback-application-name'
                            InputLabelProps={{
                                shrink: true
                            }}
                            label='Name'
                            fullWidth
                            required
                        />
                        <TextField
                            variant='standard'
                            sx={{ mb: 2 }}
                            value={feedback.email}
                            onChange={onEmailChange}
                            error={Boolean(feedback.email) && !emailRegExp.test(feedback.email)}
                            helperText={
                                feedback.email &&
                                !emailRegExp.test(feedback.email) &&
                                'Please enter a valid email address.'
                            }
                            margin='dense'
                            id='feedback-application-email'
                            InputLabelProps={{
                                shrink: true
                            }}
                            label='Email Address'
                            fullWidth
                            required
                        />
                        <TextField
                            variant='standard'
                            sx={{ mb: 2 }}
                            value={feedback.phoneNumber}
                            onChange={onPhoneChange}
                            margin='dense'
                            id='feedback-application-phone'
                            InputLabelProps={{
                                shrink: true
                            }}
                            label='Phone Number'
                            fullWidth
                        />
                    </>
                )}
                <TextField
                    variant='standard'
                    sx={{ overflowY: 'visible', height: 'auto' }}
                    value={feedback.description}
                    onChange={onDescriptionChange}
                    margin='dense'
                    id='feedback-application-description'
                    InputLabelProps={{
                        shrink: true
                    }}
                    label='Feedback Description'
                    multiline
                    required
                    rows={4}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} alignItems='center' justifyContent='space-between'>
                <Button onClick={handleOnClose} className='cancel-button'>
                    Cancel
                </Button>
                <Tooltip
                    arrow
                    title='Please fill out all required fields'
                    placement='top'
                    // The tooltip will now only show when the button is disabled
                    open={!hasRequiredFields()}
                >
                    {/* A span is needed for the Tooltip to work on a disabled button */}
                    <span>
                        <Button
                            id='feedback-application-submit'
                            onClick={handleOnSubmit}
                            disabled={!hasRequiredFields()}
                            // --- THIS IS THE SECONDARY FIX ---
                            // The `component='div'` prop is removed.
                            className='submit-button'>
                            Submit
                        </Button>
                    </span>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

export default AppFeedback;